import { EventBus, EVENTS } from '@/services/event-bus'
import { FILTER_PAGE_PATH } from '@/config/paths.js'

export const navSettings = {
  mobileBreakpoint: On.MediaQueries.width.larger,
  transitionTime: 300,
  subnavOpenDelay: 350,
  subnavOpenClass: 'subnav-is-open',
  teaserLinkClass: 'sub-navigation__teaser-link',
}

export const handleFilterToFilterPageNavigation = function (href) {
  href.includes(FILTER_PAGE_PATH) && document.location.href.includes(FILTER_PAGE_PATH)
    ? EventBus.$emit(EVENTS.filter.navigationToOtherFilterPage, { href, isNavigation: true })
    : (window.location = href)
}
